export default [
    // {
    //     url: "https://animebytes.tv/",
    //     name: "Animebytes",
    //     category: "Torrent"
    // },
    {
        category: "Torrent",
        url: "https://gazellegames.net/",
        name: "Gazelle Games"
    },
    {
        name: "LibGen",
        url: "https://libgen.is",
        category: "Torrent"
    },
    {
        category: "Torrent",
        url: "https://thepiratebay10.org",
        name: "Pirate Bay"
    },
    {
        category: "Torrent",
        url: "https://redacted.ch/",
        name: "Redacted"
    },
    {
        category: "Torrent",
        url: "https://torrent.kalenpw.com",
        name: "Web interface"
    },
    //////////
    // misc //
    //////////
    {
        name: "kalen.pw",
        url: "https://kalen.pw",
        category: "Misc",
    },
    {
        name: "blog.kalen.pw",
        url: "https://blog.kalen.pw",
        category: "Misc",
    },
    {
        name: "cloud.kalenpw.com",
        url: "https://cloud.kalenpw.com/app/files",
        category: "Misc"
    },
    {
        name: "Mastodon",
        url: "https://mastodon.social",
        category: "Misc",
    },
    {
        name: "Hacker News",
        url: "https://news.ycombinator.com/",
        category: "Misc",
    },
    {
        name: "Proton Mail",
        url: "https://mail.protonmail.com/login",
        category: "Misc",
    },
    {
        name: "AOL Mail",
        url: "https://mail.aol.com/webmail-std/en-us/suite",
        category: "Misc",
    },
    //////////////
    // Japanese //
    //////////////
    // {
    //     category: "Japanese",
    //     url: "https://www.tofugu.com/learn-japanese/",
    //     name: "Tofugu Guide"
    // },
    // {
    //     category: "Japanese",
    //     url: "https://kana-quiz.tofugu.com/",
    //     name: "Tofugu Kana Quiz"
    // },
    // {
    //     category: "Japanese",
    //     url: "https://drive.google.com/drive/u/3/folders/1q_zQ3gekqV6aVaik3uX8sZ6Nkr8CAHOF",
    //     name: "Genki PDF"
    // },
    // {
    //     category: "Japanese",
    //     url: "https://www.wanikani.com/",
    //     name: "WaniKani"
    // },
    // {
    //     category: "Japanese",
    //     url: "https://www.duolingo.com/learn",
    //     name: "Duolingo"
    // },
    ///////////
    // Money //
    ///////////
    {
        category: "Money",
        name: "Mint",
        url: "https://mint.intuit.com/"
    },
    {
        category: "Money",
        name: "Alliant",
        url: "https://www.alliantcreditunion.org/"
    },
    {
        category: "Money",
        name: "Capital One",
        url: "https://www.capitalone.com/"
    },
    {
        category: "Money",
        name: "American Express",
        url: "https://www.americanexpress.com/en-us/account/login"
    },
    {
        category: "Money",
        name: "Citi",
        url: "https://www.citi.com/"
    },
    {
        category: "Money",
        name: "SoFi",
        url: "https://www.sofi.com/"
    },
    {
        category: "Money",
        name: "Robinhood",
        url: "https://robinhood.com"
    },
    {
        category: "Money",
        name: "Fidelity",
        url: "https://login.fidelity.com/ftgw/Fas/Fidelity/RtlCust/Login/Init"
    },
    {
        category: "Money",
        name: "Vanguard",
        url: "https://investor.vanguard.com/home"
    },
    {
        category: "Money",
        name: "Wealthfront",
        url: "https://www.wealthfront.com/login"
    },
    {
        category: "Money",
        name: "Nelnet",
        url: "https://secure.nelnet.com/account/login"
    },
    ///////////////////
    // ENTERTAINMENT //
    ///////////////////
    {
        name: "Hulu",
        url: "https://www.hulu.com",
        category: "Entertainment",
    },
    {
        name: "Netflix",
        url: "https://www.netflix.com/browse",
        category: "Entertainment",
    },
    {
        name: "Disney+",
        url: "https://www.disneyplus.com/",
        category: "Entertainment",
    },
    {
        category: "Entertainment",
        name: "Google Podcasts",
        url: "https://podcasts.google.com"
    },
];
